/* eslint-disable security/detect-non-literal-regexp */
/**
 * Retrieves the company and location IDs from a URL.
 * 
 * @param {string} url - The URL from which to extract the IDs.
 * @returns {Object} - An object containing the company ID and location ID.
 * @property {string|undefined} companyId - The ID of the company extracted from the URL.
 * @property {string|undefined} locationId - The ID of the location extracted from the URL.
 */
export function getCompanyAndLocationIdsFromUrl(url) {
  const companyId = searchResourceIdInUrl(url, ['company', 'companies']);
  const locationId = searchResourceIdInUrl(url, ['location', 'locations']);
  return {
    companyId,
    locationId
  };
}

/**
 * Searches for a specific resource ID in the URL.
 *
 * @param {string} url - The URL to search within.
 * @param {string[]} resourceLabels - An array of resource labels to search for.
 * @returns {string|undefined} The matched resource ID or undefined if not found.
 */
export function searchResourceIdInUrl(url, resourceLabels = []) {
  if (!url || typeof url !== 'string' || resourceLabels.length === 0) {
    return undefined;
  }
  const regex = new RegExp(`(${resourceLabels.join('|')})/([\\w\\d]+)`);
  const match = url.match(regex);
  return match?.[2];
}